import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import Explore from "@/pages/Explore";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/explore")({
  head: () => ({
    meta: [
      { title: "Explore Football Leagues & Predictions | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["leagues", "footballPredictions"] }).meta },
      { name: "description", content: "Predictions for every major football competition — leagues, cups, international tournaments. Confidence-ranked with reasoning you can actually check." },
      { property: "og:title", content: "Explore Football Leagues & Predictions | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Predictions for every major football competition — leagues, cups, international tournaments. Confidence-ranked with reasoning you can actually check." },
      { name: "twitter:title", content: "Explore Football Leagues & Predictions | Statlign" },
      { name: "twitter:description", content: "Predictions for every major football competition — leagues, cups, international tournaments. Confidence-ranked with reasoning you can actually check." },
    ],
  }),
  component: () => (
    <MainLayout>
      <Explore />
    </MainLayout>
  ),
});
